module.exports = __webpack_public_path__ + "img/imagemHPV.4fd90f86.jpg";